module.exports = __webpack_public_path__ + "static/003-8edcd4cec8541a0b9405146bfcec55a6.jpeg";